$(document).ready(function() {

    /* Simple FAQ toggles */
    document.querySelectorAll(".faq-question").forEach((q) => {
      q.addEventListener("click", () => {
        const item = q.parentElement;
        const isOpen = item.classList.contains("open");
        document.querySelectorAll(".faq-item").forEach((i) =>
          i.classList.remove("open")
        );
        if (!isOpen) item.classList.add("open");
      });
    });

    /* Video Autoplay (main vs mood) */
(function () {
  const ALL_VIDEOS = Array.from(document.querySelectorAll('.wb-autoplay-video'));
  if (!ALL_VIDEOS.length) return;

  const MAIN_SELECTOR = '.wb-video-main';
  const MOOD_SELECTOR = '.wb-video-mood';

  const mainVideos = ALL_VIDEOS.filter(v => v.matches(MAIN_SELECTOR));
  const moodVideos = ALL_VIDEOS.filter(v => v.matches(MOOD_SELECTOR));

  let currentMain = null; // currently “active” main video (playing / focus)
  let lastUserInteractionTime = 0;

  // ---------- helper: set playbackRate from data-speed ----------
  ALL_VIDEOS.forEach(video => {
    const speedAttr = video.getAttribute('data-speed');
    if (speedAttr) {
      const speed = parseFloat(speedAttr);
      if (!Number.isNaN(speed) && speed > 0) {
        video.playbackRate = speed;
      }
    }

    // Never show native controls; we’ll add custom ones to main videos
    video.controls = false;
  });

  // ---------- build IG-style controls for main videos ----------
  mainVideos.forEach(setupMainVideoUI);

  function setupMainVideoUI(video) {
    // Wrap video in a container if not already
    let wrapper = video.closest('.wb-video-main-wrap');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'wb-video-main-wrap';
      video.parentNode.insertBefore(wrapper, video);
      wrapper.appendChild(video);
    }

    wrapper.style.position = wrapper.style.position || 'relative';

    // Overlay container
    const overlay = document.createElement('div');
    overlay.className = 'wb-video-overlay wb-first-interaction';
    overlay.innerHTML = `
      <button type="button" class="wb-video-btn wb-video-btn--playpause" aria-label="Play or pause">
        <span class="wb-video-icon wb-video-icon--play"></span>
      </button>
      <button type="button" class="wb-video-btn wb-video-btn--mute" aria-label="Mute or unmute">
        <span class="wb-video-icon wb-video-icon--muted"></span>
      </button>
    `;
    wrapper.appendChild(overlay);

    const btnPlayPause = overlay.querySelector('.wb-video-btn--playpause');
    const btnMute = overlay.querySelector('.wb-video-btn--mute');

    // Initial state: muted, not playing (auto-play kicks in via observer)
    video.muted = true;
    video.dataset.userSound = 'off'; // track user’s sound preference

    // Update UI icons
    function refreshControls() {
      const playing = !video.paused && !video.ended;
      const soundOn = !video.muted;

      btnPlayPause.querySelector('.wb-video-icon').className =
        'wb-video-icon ' + (playing ? 'wb-video-icon--pause' : 'wb-video-icon--play');
    
      btnMute.querySelector('.wb-video-icon').className =
        'wb-video-icon ' + (soundOn ? 'wb-video-icon--unmuted' : 'wb-video-icon--muted');

      const soundClass =  (soundOn ? 'wb-video-unmuted' : 'wb-video-muted');
      wrapper.className =
        'wb-video-main-wrap ' + (playing ? 'wb-video-playing '  + soundClass : 'wb-video-paused '  + soundClass);

    }

    // Play/pause button
    btnPlayPause.addEventListener('click', (e) => {
      e.stopPropagation();
      lastUserInteractionTime = Date.now();
      ensureMainExclusive(video);

      if (video.paused) {
        safePlay(video);
      } else {
        video.pause();
      }
      overlay.className = 'wb-video-overlay';
      refreshControls();
    });

    // Mute button
    btnMute.addEventListener('click', (e) => {
      e.stopPropagation();
      lastUserInteractionTime = Date.now();
      ensureMainExclusive(video);

      video.muted = !video.muted;
      video.dataset.userSound = video.muted ? 'off' : 'on';
      refreshControls();
    });

    // Tap anywhere on video to bring it into focus, enable sound, and expose controls
    overlay.addEventListener('click', (e) => {
      console.log("Overlay clicked");
      e.preventDefault();
      lastUserInteractionTime = Date.now();
      ensureMainExclusive(video);
      if(overlay.className === 'wb-video-overlay wb-first-interaction'){

        overlay.className = 'wb-video-overlay wb-video-overlay--visible';
        // First tap: if still muted, turn sound on
        if (video.muted) {
          video.muted = false;
          video.dataset.userSound = 'on';
        }

        // Ensure it’s playing
        if (video.paused) {
          safePlay(video);
        }

      }else if(overlay.className === 'wb-video-overlay'){
        overlay.className = 'wb-video-overlay wb-video-overlay--visible';

        // Ensure it isn’t playing
        video.pause();

      }else{
        // Ensure it’s playing
        if (video.paused) {
          safePlay(video);
        }
        overlay.className = 'wb-video-overlay';
      }

      refreshControls();
      
    });

    // When main video ends, pause + reset play icon
    video.addEventListener('ended', () => {
      refreshControls();
    });

    video.addEventListener('playing', (event) => {
        console.log('Video has loaded and started playing successfully.', event);
        refreshControls();
    });

    video.addEventListener('pause', (event) => {
        console.log('Video playback has been paused.', event);
        // Add code here to execute when the video stops
        refreshControls();
    });

    // Initial UI state
    refreshControls();
  }

  // ---------- ensure only one main video is “active” ----------
  function ensureMainExclusive(targetVideo) {
    if (currentMain === targetVideo) return;

    // Pause all other main videos & mute them
    mainVideos.forEach(v => {
      if (v !== targetVideo) {
        if (!v.paused) v.pause();
        v.muted = true;
        v.dataset.userSound = v.dataset.userSound || 'off';
      }
    });

    currentMain = targetVideo;
  }

  // ---------- safe play with catch, avoid unhandled promise rejections ----------
  function safePlay(video) {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Autoplay may still be blocked; we just fail silently.
      });
    }
  }

  // ---------- IntersectionObserver for auto play / pause ----------
  const observerOptions = {
    root: null,
    threshold: buildThresholds()
  };

  function buildThresholds() {
    const thresholds = [];
    const steps = 20;
    for (let i = 0; i <= steps; i++) {
      thresholds.push(i / steps);
    }
    return thresholds;
  }

  const observer = new IntersectionObserver(onIntersection, observerOptions);

  ALL_VIDEOS.forEach(video => observer.observe(video));

  function onIntersection(entries) {
    // We’ll handle main + mood separately
    const mainEntries = [];
    const moodEntries = [];

    entries.forEach(entry => {
      const video = entry.target;
      if (video.matches(MAIN_SELECTOR)) {
        mainEntries.push(entry);
      } else if (video.matches(MOOD_SELECTOR)) {
        moodEntries.push(entry);
      }
    });

    handleMoodIntersections(moodEntries);
    handleMainIntersections(mainEntries);
  }

  // ---------- Mood videos: many can play, only when >= 0.7 visible ----------
  function handleMoodIntersections(entries) {
    const VIS_THRESHOLD = 0.7;

    entries.forEach(entry => {
      const video = entry.target;
      const visible = entry.intersectionRatio >= VIS_THRESHOLD;

      // always muted
      video.muted = true;

      if (visible) {
        if (video.paused) {
          safePlay(video);
        }
      } else {
        if (!video.paused) video.pause();
      }
    });
  }

  // ---------- Main videos: only ONE may play at a time ----------
  function handleMainIntersections(entries) {
    const VIS_THRESHOLD = 0.7;

    // For robustness, evaluate all main videos, not just those in entries
    const candidates = mainVideos.map(video => {
      const rect = video.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      const visibleHeight = Math.max(
        0,
        Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0)
      );
      const visibleWidth = Math.max(
        0,
        Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0)
      );
      const visibleArea = visibleHeight * visibleWidth;
      const totalArea = rect.width * rect.height || 1;
      const ratio = visibleArea / totalArea;

      return { video, ratio };
    });

    // Find the main video with the highest visibility over threshold
    let best = null;
    candidates.forEach(c => {
      if (c.ratio >= VIS_THRESHOLD) {
        if (!best || c.ratio > best.ratio) {
          best = c;
        }
      }
    });

    // If no main video meets the threshold, pause them all
    if (!best) {
      mainVideos.forEach(video => {
        if (!video.paused) video.pause();
      });
      currentMain = null;
      return;
    }

    const targetVideo = best.video;
    ensureMainExclusive(targetVideo);

    // Respect user’s sound preference if set
    const userSound = targetVideo.dataset.userSound || 'off';
    targetVideo.muted = userSound !== 'on';

    // Only auto-play if user didn't just manually pause something
    // (avoid fighting the user within ~400ms window)
    const now = Date.now();
    if (now - lastUserInteractionTime > 400) {
      if (targetVideo.paused) {
        safePlay(targetVideo);
      }
    }

    // Pause all other main videos
    mainVideos.forEach(video => {
      if (video !== targetVideo && !video.paused) {
        video.pause();
      }
    });
  }

  // ---------- Clean up on resize (just in case) ----------
  window.addEventListener('resize', () => {
    // IntersectionObserver recalculates automatically,
    // but we can force a tick by un/observing if needed.
    // Here we leave it – observer’s geometry is updated on layout changes.
  });
})();


    /* Image Gallery */
    (function () {
        const galleries = Array.from(
        document.querySelectorAll(".lookband-gallery[data-lookband-gallery]")
        );
        if (!galleries.length) return;

        const WHEEL_COOLDOWN_MS = 400; // prevent crazy fast scrolling

        galleries.forEach(setupLookbandGallery);

         // ---------- External wiring: product images → gallery slides ----------
        // Any <img.product-image> with data-gallery_handler will control
        // its local .lookband-gallery in the same .lookband article.
        document.addEventListener('pointerup', function (event) {
            const img = event.target.closest('img.product-image[data-gallery_handler]');
            if (!img) return;

            // Prevent default only for our wiring – you already use @click.prevent in markup
            event.preventDefault();

            // 1. Find the closest lookband container
            const lookband = img.closest('.lookband');
            if (!lookband) return;

            // 2. Find the gallery in this lookband
            const gallery = lookband.querySelector('.lookband-gallery[data-lookband-gallery]');
            if (!gallery || typeof gallery._goToSlide !== 'function' || !Array.isArray(gallery._slides)) {
                // Gallery not initialized yet or missing
                return;
            }

            const handle = img.getAttribute('data-gallery_handler');
            if (!handle) return;

            // 3. Find the matching slide in this gallery
            //    We use data-product-handle to match, as you described.
            const slides = gallery._slides;
            let targetSlide = null;

            for (let i = 0; i < slides.length; i++) {
                const slide = slides[i];
                if (slide.dataset.productHandle === handle) {
                    targetSlide = slide;
                    break;
                }
            }

            if (!targetSlide) {
                // Fallback: if you ever want to match by index instead,
                // you could read img.dataset.product_index here and map manually.
                console.warn('[lookbook] No slide found for handle', handle);
                return;
            }

            // 4. Determine target slide index from data-position or else from array index
            let targetIndex;

            if (targetSlide.dataset.position != null) {
                // Assuming your data-position is already 0-based (e.g. "4" → goToSlide(4))
                targetIndex = parseInt(targetSlide.dataset.position, 10);
                if (Number.isNaN(targetIndex)) {
                    targetIndex = slides.indexOf(targetSlide);
                }
            } else {
                targetIndex = slides.indexOf(targetSlide);
            }

            if (targetIndex < 0) return;

            // 5. Jump gallery to that slide
            gallery._goToSlide(targetIndex);
        });

        function setupLookbandGallery(gallery) {
          const slides = Array.from(gallery.querySelectorAll(".lookband-slide"));
          if (slides.length <= 1) return;

          let currentIndex = 0;
          let pointerDown = false;
          let startX = 0;
          let startY = 0; // NEW: capture Y to compare direction
          let galleryWidth = gallery.clientWidth;
          let horizontalDragActive = false; // NEW: only true once horizontal intent confirmed

          /* Gallery controls START */

          // ----- Controls: video icon, image indicator + arrows -----

          // Find video slide index (usually 0) and image slides
          const videoIndex = slides.findIndex((s) => !!s.querySelector('video'));
          const imageSlides = slides.filter((s) => !s.querySelector('video'));
          const totalImages = imageSlides.length;

          // Create controls container (re-using .lookband-dots for layout)
          const controlsContainer = document.createElement('div');
          controlsContainer.className = 'lookband-dots';

          // --- Video button ---
          const videoButton = document.createElement('button');
          videoButton.type = 'button';
          videoButton.className = 'lookband-dot lookband-dot--video';
          videoButton.setAttribute('aria-label', 'Show video');

          // Always jump to the video slide (0 in your spec)
          videoButton.addEventListener('click', () => {
            const target = videoIndex >= 0 ? videoIndex : 0;
            goToSlide(target);
          });

          // --- Image icon + counter ---
          const imageControls = document.createElement('div');
          imageControls.className = 'lookband-image-controls';

          // Clickable image icon (takes you to first image slide)
          const imageButton = document.createElement('button');
          imageButton.type = 'button';
          imageButton.className = 'lookband-dot lookband-dot--image';
          imageButton.setAttribute('aria-label', 'Show images');
          // you can style this via .lookband-dot--image or add inner icon markup if needed

          imageButton.addEventListener('click', () => {
            if (!imageSlides.length) return;
            const firstImageIndex = slides.indexOf(imageSlides[0]);
            if (firstImageIndex >= 0) {
              goToSlide(firstImageIndex);
            }
          });

          // Counter: current / total (e.g. 1 / 20)
          const counter = document.createElement('span');
          counter.className = 'lookband-image-counter';

          const counterCurrent = document.createElement('span');
          counterCurrent.className = 'lookband-image-counter-current';

          const divider = document.createTextNode('/');
          const counterTotal = document.createElement('span');
          counterTotal.className = 'lookband-image-counter-total';

          counter.appendChild(counterCurrent);
          counter.appendChild(divider);
          counter.appendChild(counterTotal);

          // Add image icon + counter into imageControls
          imageControls.appendChild(imageButton);
          imageControls.appendChild(counter);

          // --- Arrows ---
          const prevButton = document.createElement('button');
          prevButton.type = 'button';
          prevButton.className = 'lookband-arrow lookband-arrow--prev';
          prevButton.setAttribute('aria-label', 'Previous slide');
          prevButton.addEventListener('click', prevSlide);

          const nextButton = document.createElement('button');
          nextButton.type = 'button';
          nextButton.className = 'lookband-arrow lookband-arrow--next';
          nextButton.setAttribute('aria-label', 'Next slide');
          nextButton.addEventListener('click', nextSlide);

          ;

          // Assemble controls
          controlsContainer.appendChild(prevButton);
          controlsContainer.appendChild(videoButton);
          controlsContainer.appendChild(imageControls);
          controlsContainer.appendChild(nextButton)

          // Append controls inside .lookband-media (parent of gallery)
          const mediaWrapper = gallery.parentElement;
          mediaWrapper.appendChild(controlsContainer);

          // ---- Controls updater ----
          function updateControls() {
            // active states
            const isOnVideo = videoIndex >= 0 && currentIndex === videoIndex;
            videoButton.classList.toggle('is-active', isOnVideo);

            // treat "image mode" as not-on-video
            imageButton.classList.toggle('is-active', !isOnVideo);

            // update counter only if we have images
            if (!totalImages) {
              counterCurrent.textContent = '0';
              counterTotal.textContent = '0';
              return;
            }

            counterTotal.textContent = String(totalImages);

            const currentSlide = slides[currentIndex];
            const imgIdx = imageSlides.indexOf(currentSlide);

            if (imgIdx !== -1) {
              // we are on an image slide: 1-based index
              counterCurrent.textContent = String(imgIdx + 1);
            } else {
              // we are on video or something else; show first image index by default
              counterCurrent.textContent = '1';
            }
          }
          /* Gallery controls END */

          function goToSlide(index) {
              if (!slides.length) return;
              // wrap around
              currentIndex = (index + slides.length) % slides.length;
              const offset = -currentIndex * 100;
              gallery.style.transition = "transform 0.35s ease-out";
              gallery.style.transform = "translateX(" + offset + "%)";
              updateControls();
          }

          function nextSlide() {
              goToSlide(currentIndex + 1);
          }

          function prevSlide() {
              goToSlide(currentIndex - 1);
          }

          // Expose goToSlide + slides on the gallery element
          gallery._goToSlide = goToSlide;
          gallery._slides = slides;

          // ---- Drag / swipe navigation (Pointer Events) ----
          function onPointerDown(e) {
              if (e.pointerType === "mouse" && e.button !== 0) return;
              pointerDown = true;
              horizontalDragActive = false; // reset
              startX = e.clientX;
              startY = e.clientY; // NEW
              galleryWidth = gallery.clientWidth;
              gallery.style.transition = "none";
              // NOTE: do NOT setPointerCapture yet; wait for horizontal intent
          }

          function onPointerMove(e) {
              if (!pointerDown) return;
              const dx = e.clientX - startX;
              const dy = e.clientY - startY;

              // If horizontal drag not yet activated, decide intent
              if (!horizontalDragActive) {
              const ABS_DX = Math.abs(dx);
                  const ABS_DY = Math.abs(dy);
              // Require some minimum horizontal movement and dominance over vertical
              if (ABS_DX > 10 && ABS_DX > ABS_DY) {
                  horizontalDragActive = true;
                  gallery.setPointerCapture(e.pointerId); // lock only now
              } else if (ABS_DY > ABS_DX) {
                  // Vertical dominates: abort horizontal interaction, let page scroll
                  return;
              } else {
                  // Not enough movement yet
                  return;
              }
              }

              // Only apply transform for confirmed horizontal drags
              const percentage = (dx / galleryWidth) * 100;
              const baseOffset = -currentIndex * 100;
              gallery.style.transform = "translateX(" + (baseOffset + percentage) + "%)";
          }

          function onPointerUp(e) {
              if (!pointerDown) return;
              pointerDown = false;

              // If we never activated horizontal drag, just cleanup & exit
              if (!horizontalDragActive) {
              gallery.style.transition = "transform 0.35s ease-out";
              return;
              }

              horizontalDragActive = false;
              gallery.releasePointerCapture(e.pointerId);
              gallery.style.transition = "transform 0.35s ease-out";

              const endX = e.clientX;
              const dx = endX - startX;

              const swipeThreshold = galleryWidth * 0.2;
              if (Math.abs(dx) > swipeThreshold) {
              if (dx < 0) {
                  goToSlide(currentIndex + 1);
              } else {
                  goToSlide(currentIndex - 1);
              }
              } else {
              goToSlide(currentIndex);
              }
          }

          gallery.addEventListener("pointerdown", onPointerDown);
          gallery.addEventListener("pointermove", onPointerMove);
          gallery.addEventListener("pointerup", onPointerUp);
          gallery.addEventListener("pointercancel", onPointerUp);

          // Prevent image dragging ghost effect
          slides.forEach((slide) => {
              slide.addEventListener("dragstart", (e) => e.preventDefault());
          });

          // Make sure we start on first slide
          goToSlide(0);

          // Optional: if layout changes (e.g. resize), update width
          window.addEventListener("resize", () => {
              galleryWidth = gallery.clientWidth;
          });
        }
    })();

    /* Product Recommender */
    (function () {
        document.addEventListener("click", function (event) {
        // Find the closest <a> inside a .recommended-products section
        const link = event.target.closest(".recommended-products a");
        if (!link) return; // click was somewhere else

        const container = link.closest(".recommended-products");
        if (!container) return;

        container.classList.add("active");
        // If you ever want to toggle instead of only add:
        // container.classList.toggle("active");
        });
    })();

});

// ---------- Horizon drawer helper (unchanged) ----------
function openHorizonCartDrawer(cartData, done) {
  try {
    document.dispatchEvent(new CustomEvent('cart:refresh:opend'));

    const cartItemsComponent = document.querySelector('cart-items-component');
    if (!cartItemsComponent) return;

    const sectionId = cartItemsComponent.getAttribute('data-section-id');
    if (!sectionId) return;

    fetch('?sections=' + sectionId, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => response.json())
      .then((sections) => {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: cartData && cartData.item_count ? cartData.item_count : 1,
                productId: cartData && cartData.product_id ? cartData.product_id : null,
                sections: sections
              },
              resource: {},
              sourceId: cartData && cartData.id ? cartData.id : null
            }
          })
        );

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && cartDrawer.showDialog) {
          cartDrawer.showDialog();
        }
        if (done && typeof done === 'function') {
          done();
        }
      })
      .catch((err) => console.error('Horizon cart drawer refresh error', err));
  } catch (e) {
    console.error('Horizon cart drawer error', e);
  }
}

// ---------- Alpine component ----------
document.addEventListener('alpine:init', () => {
  Alpine.data('wearberryCapsule', () => ({
    // Modal state (generic, not just full look)
    modalOpen: false,
    modalMode: null, // 'look' | 'capsule' | 'product'
    modalTitle: '',
    addingBundle: false,

    // Look-level state
    activeLookKey: null,
    activeItems: [],      // for look/capsule bundle modal

    // Quickview state
    quickviewProduct: null,
    quickviewGalleryIndex: 0,

    // All looks data, injected from Liquid JSON
    allLooks: [],

    // GLOBAL size selections, keyed by product handle
    // { [handle: string]: variantId }
    sizeSelections: {},

    // ---------- Init: load JSON from <script id="wb-lookbook-data"> ----------
    init() {
      let json = null;
      const el = document.getElementById('wb-lookbook-data');
      if (el && el.textContent) {
        try {
          json = JSON.parse(el.textContent);
        } catch (e) {
          console.error('Failed to parse wb-lookbook-data JSON', e);
        }
      } else if (window.wbLookbookData) {
        json = window.wbLookbookData;
      }

      if (json && Array.isArray(json.looks)) {
        this.allLooks = json.looks;
      } else {
        this.allLooks = [];
      }
    },

    // ---------- Size selection helpers (GLOBAL across page) ----------
    getSelectedVariantId(handle) {
      if (!handle) return null;
      return this.sizeSelections[handle] || null;
    },

    selectVariant(handle, variantId) {
      if (!handle || !variantId) return;
      this.sizeSelections = {
        ...this.sizeSelections,
        [handle]: variantId
      };

      // Also sync into activeItems if open in bundle modal
      if (this.activeItems && this.activeItems.length) {
        this.activeItems.forEach((item) => {
          if (item.handle === handle) {
            item.selectedVariantId = variantId;
          }
        });
      }

      // And sync into quickview if same product is open
      if (this.quickviewProduct && this.quickviewProduct.handle === handle) {
        this.quickviewProduct.selectedVariantId = variantId;
      }
    },

    // ---------- Derived: capsule items = all products from all looks ----------
    get capsuleItems() {
      const items = [];
      this.allLooks.forEach((look) => {
        (look.items || []).forEach((item) => {
          items.push(item);
        });
      });
      return items;
    },

    // ---------- OPEN MODALS ----------

    openLookBundle(lookKey) {
      const look = this.allLooks.find((l) => l.key === lookKey);
      if (!look) {
        console.warn('Unknown look key', lookKey);
        return;
      }

      this.modalMode = 'look';
      this.modalTitle = look.title || 'Full look';
      this.activeLookKey = lookKey;

      // Deep copy and inject selection/quantity
      this.activeItems = (look.items || []).map((item) => {
        const clone = JSON.parse(JSON.stringify(item));
        const variants = clone.variants || [];

        // 1) try saved global selection
        const saved = this.getSelectedVariantId(clone.handle);

        let chosenVariant = null;
        if (saved) {
          chosenVariant = variants.find((v) => v.id === saved) || null;
        }

        // 2) fallback: first available
        if (!chosenVariant) {
          chosenVariant =
            variants.find((v) => v.available) ||
            (variants.length ? variants[0] : null);
        }

        clone.selectedVariantId = chosenVariant ? chosenVariant.id : null;
        clone.quantity = 1;

        return clone;
      });

      this.modalOpen = true;
    },

    openCapsuleBundle() {
      const items = this.capsuleItems;
      if (!items.length) {
        console.warn('No items for capsule bundle');
        return;
      }

      this.modalMode = 'capsule';
      this.modalTitle = 'Full capsule > Choose Your Sizes';
      this.activeLookKey = null;

      this.activeItems = items.map((item) => {
        const clone = JSON.parse(JSON.stringify(item));
        const variants = clone.variants || [];

        const saved = this.getSelectedVariantId(clone.handle);

        let chosenVariant = null;
        if (saved) {
          chosenVariant = variants.find((v) => v.id === saved) || null;
        }

        if (!chosenVariant) {
          chosenVariant =
            variants.find((v) => v.available) ||
            (variants.length ? variants[0] : null);
        }

        clone.selectedVariantId = chosenVariant ? chosenVariant.id : null;
        clone.quantity = 1;

        return clone;
      });

      this.modalOpen = true;
    },

    openProductQuickview(handle) {
      let productItem = null;

      // Find the first item with this handle
      this.allLooks.some((look) => {
        const found = (look.items || []).find((i) => i.handle === handle);
        if (found) {
          productItem = found;
          return true;
        }
        return false;
      });

      if (!productItem) {
        console.warn('No product found for quickview handle', handle);
        return;
      }

      const clone = JSON.parse(JSON.stringify(productItem));
      const variants = clone.variants || [];

      const saved = this.getSelectedVariantId(clone.handle);

      let chosenVariant = null;
      if (saved) {
        chosenVariant = variants.find((v) => v.id === saved) || null;
      }

      if (!chosenVariant) {
        chosenVariant =
          variants.find((v) => v.available) ||
          (variants.length ? variants[0] : null);
      }

      clone.selectedVariantId = chosenVariant ? chosenVariant.id : null;
      clone.quantity = 1;

      this.modalMode = 'product';
      this.modalTitle = clone.title || 'Product details';
      this.quickviewProduct = clone;
      this.quickviewGalleryIndex = 0;
      this.modalOpen = true;
    },

    // ---------- Helpers ----------

    isBundleMode() {
      return this.modalMode === 'look' || this.modalMode === 'capsule';
    },

    quickviewSelectedVariant() {
      if (!this.quickviewProduct || !Array.isArray(this.quickviewProduct.variants)) {
        return {};
      }
      const id = this.quickviewProduct.selectedVariantId;
      const found =
        this.quickviewProduct.variants.find((v) => v.id === id) ||
        this.quickviewProduct.variants[0] ||
        {};
      return found;
    },

    closeModal() {
      this.modalOpen = false;
      this.modalMode = null;
      this.activeItems = [];
      this.quickviewProduct = null;
      this.activeLookKey = null;
      this.addingBundle = false;
    },

    // ---------- Add to cart: bundles (look + capsule) ----------

    bulkAddBundle() {
      if (!this.isBundleMode() || !this.activeItems || !this.activeItems.length) {
        return;
      }

      const items = [];

      this.activeItems.forEach((item) => {
        const variantId = item.selectedVariantId;
        if (!variantId) {
          console.warn('Missing variantId for item', item.title);
          return;
        }
        items.push({
          id: variantId,
          quantity: item.quantity || 1
        });
      });

      if (!items.length) {
        alert('Please select sizes for each piece.');
        return;
      }

      if (!window.CartJS) {
        console.error('CartJS not found – did the script load correctly?');
        alert('Sorry, something went wrong with the cart. Please try again.');
        return;
      }

      this.addingBundle = true;

      CartJS.addItems(items, {
        success: (data) => {
          console.log('Bulk items added', data);
          openHorizonCartDrawer(data, () => {
            this.closeModal();
          });
        },
        error: (jqXHR) => {
          console.error('CartJS bulk add failed', jqXHR);
          this.addingBundle = false;
          if (jqXHR.statusText === 'error') {
            alert('Sorry, we could not add the items. ' + jqXHR.responseJSON.message);
          }
        }
      });
    },

    // ---------- Add to cart: single product from quickview ----------

    addQuickviewItem() {
      if (!this.quickviewProduct || !this.quickviewProduct.selectedVariantId) {
        return;
      }

      if (!window.CartJS) {
        console.error('CartJS not found');
        alert('Sorry, something went wrong with the cart. Please try again.');
        return;
      }

      this.addingBundle = true;

      CartJS.addItem(
        this.quickviewProduct.selectedVariantId,
        this.quickviewProduct.quantity || 1,
        {},
        {
          success: (data) => {
            console.log('Quickview item added', data);
            openHorizonCartDrawer(data, () => {
              this.closeModal();
            });
          },
          error: (jqXHR) => {
            console.error('CartJS single item add failed', jqXHR);
            this.addingBundle = false;
            if (jqXHR.statusText === 'error') {
              alert('Sorry, we could not add the item. ' + jqXHR.responseJSON.message);
            }
          }
        }
      );
    },

    // ---------- Single-item add from product cards ----------
    addSingleItem(variantId, quantity = 1) {
      if (!window.CartJS) {
        console.error('CartJS not found');
        return;
      }

      CartJS.addItem(variantId, quantity, {}, {
        success: (data) => {
          console.log('Single item added', data);
          openHorizonCartDrawer(data, () => {
            this.closeModal(); // closes modal if it was open
          });
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('CartJS single item add failed', jqXHR, errorThrown);
          this.addingBundle = false;
          if (jqXHR.statusText === 'error') {
            alert('Sorry, we could not add the item. ' + jqXHR.responseJSON.message);
          }
        }
      });
    }
  }));
});


/* HLS Video Streaming Block */
document.addEventListener('DOMContentLoaded', function () {
  // console.log("Dom Loaded");
    if (!window.Hls || !Hls.isSupported()) {
      // console.log("!window.Hls || !Hls.isSupported()");
      // Fallback for Safari / native HLS
      document.querySelectorAll('video[data-hls-src]').forEach(function (video) {
        const src = video.getAttribute('data-hls-src');
        // console.log(src);
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = src;
        }
      });
      return;
    }

    document.querySelectorAll('video[data-hls-src]').forEach(function (video) {
      const src = video.getAttribute('data-hls-src');
      // console.log(video.dataset);
      // console.log(src);
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
    });
});